// John Eldhose 201800605
import { RestfulGet } from './Restful';

export async function getAddress() {
  const add = await RestfulGet('getAddress', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return add;
}



// WEBPACK FOOTER //
// ./src/Api/getAddress.js